import axios from "axios";
import API_BASE_URL from "../config";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const addAdmin = async (payload) => {
  try {
    const res = await axiosInstance.post("add-admin", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to add admin. Please try again.",
    };
  }
};

export const completeAdminRegistration = async (link, formData) => {
  try {
    const res = await axiosInstance.post(`admin-registration/${link}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to complete registration. Please try again.",
    };
  }
};

export const viewAllAdmins = async (payload = {}) => {
  try {
    const res = await axiosInstance.post("view-all-admins", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to fetch admins. Please try again.",
    };
  }
};

export const updateDgcaCompany = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "update-dgca-company",
      payload
    );

    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to update DGCA company status.",
    };
  }
};


export const setAdminKeyLimit = async (payload) => {
  try {
    const res = await axiosInstance.post(
      "set-admin-key-limit",
      payload
    );

    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to update key limit.",
    };
  }
};

export const updateAdminStatus = async (payload) => {
  try {
    const res = await axiosInstance.post("update-admin-status", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to update admin status. Please try again.",
    };
  }
};

export const switchToAdminDashboard = async (payload) => {
  try {
    const res = await axiosInstance.post("switch-to-admin", payload);
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to switch to admin dashboard. Please try again.",
    };
  }
};

export const exitAdminView = async () => {
  try {
    const res = await axiosInstance.post("exit-admin-view", {});
    return res.data;
  } catch (err) {
    return {
      error:
        err.response?.data?.error ||
        "Failed to exit admin view. Please try again.",
    };
  }
};

export const fetchSuperAdminNotifications = async (payload = {}) => {
  try {
    const response = await axiosInstance.post(
      "superadmin-notifications",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Superadmin notifications error:", error);
    throw error;
  }
};

